import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

function BotQuestionTypeSelect(props) {
  const { value, readOnly, onSelect, parentId, disableCloseText } = props;
  let options = [
    { value: 'YES', label: 'Choice' },
    { value: 'PHONENUMBER', label: 'Call' },
    { value: 'APPOINTMENT', label: 'Appointment' },
    { value: 'REGISTRATION', label: 'Registration' },
    { value: 'INTERVIEWLOCATION', label: 'Interview Location' },
    { value: 'CLOSETEXT', label: 'Closing Text' },
    { value: 'FREETEXT', label: 'Text' },
  ];
  options = disableCloseText === true ? options.filter(option => option.value !== 'CLOSETEXT') : options;
  return (
    <Select
      defaultValue={value?.toUpperCase()}
      disabled={readOnly}
      onChange={onSelect}
      style={{ width: 140 }}
      getPopupContainer={triggerNode => {
        return document.getElementById(parentId) || triggerNode.parentNode;
      }}
    >
      {options.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
}

export default BotQuestionTypeSelect;
